import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyMaskDirective } from './currency-mask.directive';
import { NumbersOnlyDirective } from './numbers-only.directive';
import { UppercaseDirective } from './uppercase.directive';


@NgModule({
  declarations: [CurrencyMaskDirective, NumbersOnlyDirective, UppercaseDirective],
  exports: [CurrencyMaskDirective, NumbersOnlyDirective, UppercaseDirective],
  imports: [
    CommonModule
  ]
})
export class DirectivesModule { }
